import React, { useEffect, useState } from "react";
import { useAuth } from "../contextos/AuthContext";
import { db } from "../firebase/firebaseConfig";
import { collection, query, where, getDocs } from "firebase/firestore";

const MiCuenta = () => {
  const { usuario } = useAuth();
  const [membresias, setMembresias] = useState([]);

  useEffect(() => {
    const cargar = async () => {
      const q = query(
        collection(db, "membresias"),
        where("estudianteId", "==", usuario.uid)
      );

      const snap = await getDocs(q);
      const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setMembresias(data);
    };

    if (usuario) cargar();
  }, [usuario]);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Mi cuenta</h2>

      <h3>Membresías</h3>

      {membresias.map((m) => (
        <div key={m.id} style={{ border: "1px solid #ccc", marginBottom: "10px", padding: "10px" }}>
          <p><strong>Plan:</strong> {m.plan}</p>
          <p><strong>Estado:</strong> {m.estado}</p>
          <p><strong>Pago:</strong> {m.estadoPago}</p>
          <p><strong>Inicio:</strong> {m.fechaInicio?.toDate?.().toLocaleDateString()}</p>
          <p><strong>Fin:</strong> {m.fechaFin?.toDate?.().toLocaleDateString()}</p>
        </div>
      ))}
    </div>
  );
};

export default MiCuenta;